import { combineReducers } from "@reduxjs/toolkit";
import logo from "./logoSlice";
const reducer = combineReducers({
  logo,
});

export default reducer;
